import React from 'react'
import styled, { css } from 'styled-components'

const Btn = styled.a`
  position: fixed;
  bottom: 1rem;
  left: 1rem;
  background: #24909a;
  border: none;
  font-size: 18px;
  font-weight: 700;
  border-radius: 0.5rem;
  padding: 0.8rem 1.6rem;
  margin: 0rem;
  color: #fff;
  pointer-events: all;
  cursor: pointer;
  z-index: 19;

  ${props =>
    !props.mobile &&
    css`
      bottom: auto;
      left: auto;
      top: 2rem;
      right: 2rem;
      :hover {
        background: #072b3b;
        -webkit-transition: background 0.4s;
        transition: background 0.4s;
      }
    `};
`

const Download = ({ mobile }) => {
  return (
    <Btn data-ga-cta-download href="https://telxius.com/network/" target="_blank" mobile={mobile}>
      Download Map
    </Btn>
  )
}

export default Download
